import React from 'react';

export const SectionHeading = ({ children, subtitle, className = '' }) => (
  <div className={`text-center ${className}`}>
    <h2 className="text-[#2E8B57] font-extrabold text-3xl sm:text-4xl tracking-tight">{children}</h2>
    {subtitle && <p className="mt-4 text-black/80 leading-7 max-w-3xl mx-auto">{subtitle}</p>}
  </div>
);
